import { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';

import { PdpSharedBlurb } from '../PdpSharedBlurbs/PdpSharedBlurb/PdpSharedBlurb';
import PdpSharedShippingInfoWrapper from '../PdpSharedShippingInfo/PdpSharedShippingInfoWrapper';
import { deliveryTitle } from '../messages/pdpDetailsMessages';

import { type PdpRespSidebarBlurbShipping_item$key } from './__generated__/PdpRespSidebarBlurbShipping_item.graphql';
import { type PdpRespSidebarBlurbShipping_user$key } from './__generated__/PdpRespSidebarBlurbShipping_user.graphql';
import { type PdpRespSidebarBlurbShipping_sku$key } from './__generated__/PdpRespSidebarBlurbShipping_sku.graphql';

// styles
import styles from '../PdpSharedBlurbs/PdpSharedBlurb/PdpSharedBlurb.scss';

const userFragment = graphql`
    fragment PdpRespSidebarBlurbShipping_user on User {
        ...PdpSharedShippingInfoWrapper_user
    }
`;

const itemFragment = graphql`
    fragment PdpRespSidebarBlurbShipping_item on Item {
        ...PdpSharedShippingInfoWrapper_item
        attributes {
            leadTime {
                option {
                    urlLabel
                }
            }
        }
    }
`;

const skuFramgent = graphql`
    fragment PdpRespSidebarBlurbShipping_sku on ItemSkuType {
        ...PdpSharedShippingInfoWrapper_sku
    }
`;

export const PdpRespSidebarBlurbShipping: FC<{
    item: PdpRespSidebarBlurbShipping_item$key;
    user: PdpRespSidebarBlurbShipping_user$key | null | undefined;
    sku: PdpRespSidebarBlurbShipping_sku$key | null | undefined;
    currency: string;
    renderTooltip?: boolean;
    isClient: boolean;
    itemQuantity?: number | null;
    shortLinkCta?: boolean;
    zeroMargin?: boolean;
}> = ({
    item: itemRef,
    user: userRef,
    sku: skuRef,
    currency,
    renderTooltip,
    isClient,
    itemQuantity,
    shortLinkCta,
    zeroMargin,
}) => {
    const item = useFragment(itemFragment, itemRef);
    const user = useFragment(userFragment, userRef);
    const sku = useFragment(skuFramgent, skuRef);

    const leadTime = item.attributes?.leadTime?.[0]?.option?.urlLabel;

    return (
        <>
            <PdpSharedBlurb
                IconComponent={null}
                zeroPadding
                zeroMargin={zeroMargin}
                iconClass={styles.printHide}
            >
                <PdpSharedShippingInfoWrapper
                    sku={sku}
                    item={item}
                    currency={currency}
                    leadTime={leadTime}
                    renderTooltip={renderTooltip}
                    user={user}
                    isClient={isClient}
                    title={<span className={styles.blurbTitle}>{deliveryTitle}</span>}
                    displayInline
                    itemQuantity={itemQuantity}
                    positioning="sidebar"
                    shortLinkCta={shortLinkCta}
                />
            </PdpSharedBlurb>
        </>
    );
};
